import { create } from "zustand"
import type { TaskNotificationsSummary } from "@/types/task-notifications"

type TaskNotificationsState = {
  summary: TaskNotificationsSummary | null
  version: number
  accept: (summary: TaskNotificationsSummary) => boolean
  refreshed: (summary: TaskNotificationsSummary) => void
}

export const useTaskNotificationsStore = create<TaskNotificationsState>((set, get) => ({
  summary: null,
  version: 0,
  accept: (summary) => {
    const current = get().summary
    if (current && current.company_id === summary.company_id && summary.at < current.at) return false
    set({ summary })
    return true
  },
  refreshed: (summary) => {
    if (get().accept(summary)) set((state) => ({ version: state.version + 1 }))
  },
}))
